export function waitUntilHeapLoaded(): Promise<void> {
  const maxAttempts = 50;
  let attemptCount = 0;

  return new Promise(resolve => {
    const intervalId = setInterval(() => {
      if (attemptCount > maxAttempts || window.heap?.loaded) {
        clearInterval(intervalId);
        resolve();
      }
      attemptCount++;
    }, 100);
  });
}
